export const PERK_LIST = [
    { id: "iron_wall", name: "Iron Wall", icon: "🛡️", desc: "+5 DEF permanently", type: "static" },
    { id: "quick_strike", name: "Quick Strike", icon: "⚡", desc: "+4 SPD permanently", type: "static" },
    { id: "last_stand", name: "Last Stand", icon: "🔥", desc: "When HP ≤ 25%: attack ×1.5 (once per battle)", type: "conditional" },
    { id: "predator", name: "Predator", icon: "🐺", desc: "+5 ATK per kill (up to 3 stacks)", type: "conditional" },
    { id: "berserker", name: "Berserker", icon: "💢", desc: "+8 ATK per 25% HP lost (up to 3 stacks)", type: "conditional" },
    { id: "guardian", name: "Guardian", icon: "🌟", desc: "+6 DEF when an ally dies (up to 3 stacks)", type: "conditional" },
];
export const PERK_BY_ID = Object.fromEntries(PERK_LIST.map(p => [p.id, p]));
